import Vue from 'vue';
window._ = require('lodash');
Vue.set(Vue.prototype, '_', _);

const expReg = {
	decimal: /^\d+(\.\d{0,2})?$/,
    decimalTasa: /^\d+(\.\d{0,5})?$/,
    email:  /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.([a-zA-Z]{2,4})+$/,
	alpha:  /^[^0-9]+$/,
	number: /^[0-9]+$/,
	letras: /^[a-zA-ZÀ-ÿ\u00f1\u00d1]+(\s*[a-zA-ZÀ-ÿ\u00f1\u00d1]*)*[a-zA-ZÀ-ÿ\u00f1\u00d1]+$/,
	url:    /(ftp|http|https):\/\/(\w+:{0,1}\w*@)?(\S+)(:[0-9]+)?(\/|\/([\w#!:.?+=&%@!\-\/]))?/ ,
	espaciado: /([ ]{2,})|[-!$%^&*()_+|~=`{}\[\]:";'<>?,.\/]/,
	compania: /^[.@&]?[a-zA-Z0-9 ]+[ !.@&()]?[ a-zA-Z0-9!()]+/
};

function inicio(v){
	return (!_.isUndefined(v) || _.isNull(v))
}

function maxn(v,n){
	return v.length <= n || "Este campo tiene un máximo de "+n
}

function min(v,n){
	return v.length >= n || "Este campo tiene un minimo de "+n
}

import XLSX from 'xlsx';
export default {
    data: function() {
		return {
			//Parametros
			tamModal : '70%',
			//Reglas
			requeridoRegla:     [ v => !!v && v != null || 'El campo es requerido' ],
			letrasRegla:        [ v => inicio(v) && /^[a-zA-ZÀ-ÿ\u00f1\u00d1]+(?:[\s.]+[a-zA-ZÀ-ÿ\u00f1\u00d1]+)*$/gi.test(v) || 'No se permite símbolos, letras o espacios innecesarios' ],
			numeroRegla:        [ v => inicio(v) && expReg.number.test(v)  || 'Solo se permite numeros' ],
            emailRegla:         [ v => inicio(v) && expReg.email.test(v) || "Ingrese un email válido"],
			max1000Regla:       [ v => inicio(v) && !_.isNull(v) ? maxn(v,1000) : false ],
            max500Regla:        [ v => !!v && v != null && v.length < 500 || "Este campo tiene un máximo de 500" ],
            max300Regla:        [ v => !!v && v != null && v.length < 300 || "Este campo tiene un máximo de 300" ],
            max200Regla:        [ v => !!v && v != null && v.length < 200 || "Este campo tiene un máximo de 200" ],
            max100Regla:        [ v => !!v && v != null && v.length < 100 || "Este campo tiene un máximo de 100" ],
            max50Regla:         [ v => !!v && v != null && v.length < 50 || "Este campo tiene un máximo de 50" ],
			max10Regla:         [ v => !!v && v != null && v.length < 10 || "Este campo tiene un máximo de 10" ],
			telefono:           [ v => !!v && v != null && v.length < 9 || "Este campo tiene un máximo de 9" ],
			decimal:            [ v => !!v && v != null && expReg.decimal.test(v) || 'Solo valores númericos y con un máximo de 2 decimales' ],
			decimalTasa:        [ v => !!v && v != null && expReg.decimalTasa.test(v) || 'Solo valores númericos y con un máximo de 5 decimales' ],
			porcentajeRegla:    [ v => expReg.decimal.test(v) && v < 100 || "Solo valores menores a 100 y con un maximo de 2 decimales" ],
			opcional: 		    [ v => inicio(v) ? false : false ],
			// urlRegla:           [ v => inicio(v) ? (expReg.url.test(v) ? false : 'Ingrese una URL válida.') : false],
			urlRegla:           [ v => !!v && v != null && expReg.url.test(v) || 'Ingrese una URL válida.' ],
			// companiaRegla:      [ v => inicio(v) ? (expReg.compania.test(v) ? false : 'Nombre de compañia incorrecto.') : false],
			companiaRegla:      [ v => !!v && v != null && expReg.compania.test(v) || 'Nombre de compañia incorrecto.' ],
			tasaRegla:          [ v => !!v && v != null && parseFloat(v) > 0 || 'El valor tasa no puede ser 0.00000'],
			edadRegla:          [ v => !!v && v < 150 || "La edad no puede ser mayor a 150 años" ],
            ruc: [
				v => {
					{
						try {
								//validar_inicial
								var num = 0;
								if (_.isUndefined(v)) throw "RUC no puede estar vacio.";
								if (_.isNull(v)) throw "RUC no puede estar vacio.";
								if(!expReg.number.test(v)) throw "Solo se deben ingresar números.";
								v = _.trim(v);
								if (v.length != 13) throw "RUC no puede ser menor a 13.";

								//validarCodigoProvincia
								num = parseInt(v.substring(0, 2));
								if (num < 1 || num > 24) throw "El número de RUC es incorrecto.";

								//validarTercerDigito
								var arrNum = _.split(v, "");

								var tipo = (o => {
												o = parseInt(o);
												if (o == 9) return "juridica";
												if (o == 6) return "publico";
												if ([0, 1, 2, 3, 4, 5].includes(o)) return "natural";
												return null;
								})(arrNum[2]);

								//Código de establecimiento

								switch (tipo) {
									case "natural":
										num = _.parseInt(_.join(_.slice(arrNum, 3, 10), ""));
									break;
									case "juridica":
										num = _.parseInt(_.join(_.slice(arrNum, 3, 9), ""));
									break;
									case "publico":
										num = _.parseInt(_.join(_.slice(arrNum, 3, 8), ""));
									break;
									default:
										throw "El número de RUC es incorrecto.";
									break;
								}

								if (num < 0) 
									throw "El número de RUC es incorrecto.";

								if (!this.modulo(arrNum, tipo))
									throw "El número de RUC es incorrecto.";
								return true;
						} catch (err) {
							return err.message || err;
						}
					}
				}
			],
            cedula: [
                v => {
                    try {
						if (_.isUndefined(v)) throw "El número de cedula es incorrecto.";
                        if (_.isNull(v)) throw "El número de cedula es incorrecto.";
						if (v.length > 10) throw "El número de cédula no puede ser mayor que 10";
                        let cedula = String(v);
                        let digitoVerificador = 0;
                        let decenaSuperior = 0;
                        let sumaProductos = 0;
                        let producto = 0;
                        cedula = cedula.split("");

                        if (cedula.length < 10)
                            throw "El número de cedula es incorrecto.";

                        _.forEach(cedula, function(val, indice) {
                            if (indice < 9) {
                                if (indice == 0 || indice % 2 == 0) {
                                    producto = parseInt(val) * 2;
                                } else {
                                    producto = parseInt(val);
                                }
                                if (producto > 9) producto -= 9;

                                sumaProductos += parseInt(producto);
                            }
                        });

                        if (sumaProductos > 9) {
                            let arrayDecenaSuperior = String(
                                sumaProductos
                            ).split("");
                            decenaSuperior =
                                (parseInt(arrayDecenaSuperior[0]) + 1) * 10;
                        } else decenaSuperior = 10;

                        digitoVerificador =
                            parseInt(decenaSuperior) - parseInt(sumaProductos);
                        if (digitoVerificador == 10) digitoVerificador = 0;

						if (digitoVerificador == cedula[9]) return true;
						throw 'El número de cedula es incorrecto.';
                    } catch (e) {
                        return e.message || e;
                    }
                }
            ]
		};
	},
	computed: {
		isMovil(){
			return _.get(this.$root,'isTouch',false);
		}
	},
	methods:{
		soloLetrasRegla(minimo,v,maximo){
					return [
						v => min(!_.isUndefined(v) && !_.isNull(v) ? v : '',minimo),
						v => maxn(!_.isUndefined(v) && !_.isNull(v) ? v : '',maximo),
						// v => /^[a-zA-ZÃ€-Ã¿\u00f1\u00d1]+(?:[\s.]+[a-zA-ZÃ€-Ã¿\u00f1\u00d1]+)*$/gi.test(v) || "No se permite nÃºmeros, sÃ­mbolos o espacios innecesarios."
					];
		},
		soloNumerosRegla(minimo,v,maximo){
			if(!_.isUndefined(v))
				return _.concat(maxn(v,maximo),min(v,minimo),this.numeroRegla);
			return false;
		},
		_validarInformacion(lista,k,v,atri){
			/*ValidaciÃ³n para listas de los dataTable*/
			// InformaciÃ³n Nueva
			if(_.isUndefined(k) || _.isNull(k)){
				return _.size(_.filter(lista, (ob) => { return parseInt(_.get(ob,atri)) == parseInt(v); })) > 0 ? true : false;
			}else //InformaciÃ³n Editar
				return _.size(_.filter(_.filter(lista, (v,key) => { return key != parseInt(k); }),(ob) => { return parseInt(_.get(ob,atri)) == parseInt(v) })) > 0 ? true : false;
		},
		_getBase64(file){
			return new Promise((resolve, reject) => {
				const reader = new FileReader();
				reader.readAsDataURL(file);
				reader.onload = () => resolve(reader.result);
				reader.onerror = error => reject(error);
			});
		},
		modulo(arr, tipo) {
			var mod = 11;
			switch (tipo) {
				case "natural":
								mod = 10;
								var digitosIniciales = _.slice(arr, 0, 9);
								var digitoVerificador = parseInt(arr[9]);
								var arrayCoeficientes = [2, 1, 2, 1, 2, 1, 2, 1, 2];
								break;
				case "juridica":
								var digitosIniciales = _.slice(arr, 0, 9);
								var digitoVerificador = parseInt(arr[9]);
								var arrayCoeficientes = [4, 3, 2, 7, 6, 5, 4, 3, 2];
								break;
				case "publico":
								var digitosIniciales = _.slice(arr, 0, 8);
								var digitoVerificador = parseInt(arr[8]);
								var arrayCoeficientes = [3, 2, 7, 6, 5, 4, 3, 2];
								break;
			}

			var total = 0;

			_.forEach(digitosIniciales, (value, key) => {
				var valorPosicion =
								parseInt(value) * arrayCoeficientes[key];
				if (tipo == "natural" && valorPosicion >= 10) {
					valorPosicion = _.reduce(
						_.split(valorPosicion, ""),(sum, n) => {
							return sum + parseInt(n);
						},0
					);
				}
				total += valorPosicion;
			});

			var residuo = total % mod;
			var resultado = 0;

			if (residuo == 0) resultado = 0;
			else resultado = mod - residuo;

			if (resultado != digitoVerificador) return false;
			return true;
		},
		exportar(idTable,nameFile,removeEnd=true){    
			var wbout = XLSX.utils.table_to_book(document.getElementById(idTable), {sheet:"Hoja 1"});
			
			var l = _.get(wbout,['Sheets','Hoja 1'],[]);
			var o = {};
			var keys =  ["ver","visibility","acción","accion"];

			l = _.map(l,(vv,k)=>{
				if(k.includes('1'))
					vv.v = _.replace(vv.v,'arrow_upward','');
				
				if(removeEnd && !_.includes(keys,_.toLower(vv.v)))
					_.set(o,k,vv);

				return vv;
			   });
			_.set(wbout,['Sheets','Hoja 1'],o);
			
			return XLSX.writeFile(wbout, (`${nameFile}-${moment().format('YYYY-MM-DD h:mm:ss')}.xlsx`));
		},
		readXLS(file, sheet, cab=[]) {
			return new Promise((resolve, reject) => {
				var reader = new FileReader();
				reader.onload = function (e) {

					var workbook = XLSX.read(e.target.result, {
						type: 'binary',
						sheetRows: 0,
					});

					var she = _.get(workbook.Sheets, sheet);
					if (_.isUndefined(she)) return reject(`No se encontro ${sheet}`);

					var d = XLSX.utils.sheet_to_json(she, {
						header: 1,
					});

					if (d.length == 0) return reject(`No se encontraron registros en ${sheet}`);

					if(cab.length > 0){
						if (!_.isEqual(_.map(d.shift(), _.trim), cab)) return reject(`El formato de ${sheet} no es correcto`);
	
						cab = _.map(cab, _.camelCase);
	
						d = _.map(d, (o) => {
							return _.zipObject(cab, o);
						});
					}

					return resolve(d);					
				};
				reader.readAsBinaryString(file);
			});
		},
		formatNumber(num){
			return _.round(num,2).toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,');
		}
	},
	created(){
		_.set(window,'mensajesAlerta', this.$root.mensajeAlerta);
		_.set(window,'loading', this.$root.onCargando);
		_.set(window,'mensajeAlertaTiempo', this.$root.notificacionMensaje);
	}
};

